<template>
  <Checkbox
    :label="label"
    name="priorAcceptanceCheckbox"
    :checked="checked"
    :validation-errors="v$.value.checkedOption"
    @input="onFieldChange('checkedOption', $event)"
  />
</template>

<script>
import Checkbox from "../forms/SharedComponents/CheckBox.vue";
import formInputs from "../../mixins/formInputs";
import useVuelidate from "@vuelidate/core";
import { PRIOR_ACCEPTANCE_COMMON_TEXT, PRIOR_ACCEPTANCE_TEXT_IF_STATUS, CONDITIONAL_STATUSES } from "./constants";
const validateEquality = (value) => {
  return value === true;
};

export default {
  name: "PriorAcceptance",
  components: { Checkbox },
  mixins: [formInputs],
  props: {
    priorAcceptance: {
      type: Object,
      default: function () {
        return {};
      },
    },
    checked: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: "",
    },
  },
  emits: ["update:prior-acceptance"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      value: {
        checkedOption: false,
      },
    };
  },
  computed: {
    label() {
      return `${
        CONDITIONAL_STATUSES.includes(this.status) ? PRIOR_ACCEPTANCE_TEXT_IF_STATUS : ""
      }${PRIOR_ACCEPTANCE_COMMON_TEXT}`;
    },
  },
  watch: {
    value: {
      handler: function () {
        this.$emit("update:prior-acceptance", this.value);
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {
    value: {
      checkedOption: {
        sameAs: validateEquality,
      },
    },
  },
};
</script>
